import API from '@axios'
import { apiHelper } from '../helpers/apiHelper'

const API_URL = '/api/core/settings'

export default {
  ...apiHelper(API_URL),
  patch: payload => API.patch(`${API_URL}`, payload),
}
